import React from "react";

export default function SiteFooter() {
    return (
        <footer id="site-footer">
            <div id="colophon">
                <p><small>This site is <a href="https://create-react-app.dev/" target="_blank" rel="noopener noreferrer">built with Create React App</a>.</small></p>
            </div>
        </footer>
    );
}


// WEBPACK FOOTER //
// ./src/components/SiteFooter.js